import { useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const SUPPORTED_LANGUAGES = ['en', 'tr', 'nl', 'fr', 'ar'] as const;
type Language = typeof SUPPORTED_LANGUAGES[number];

export const LanguageRouteWrapper = () => {
  const { lang } = useParams<{ lang?: string }>();
  const { setLanguage, language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If we have a language in the URL, set it
    if (lang && SUPPORTED_LANGUAGES.includes(lang as Language)) {
      if (lang !== language) {
        setLanguage(lang as Language);
      }
    }
  }, [lang, setLanguage, language]);

  // Handle redirect for /en/ to / (English is default)
  useEffect(() => {
    if (lang === 'en') {
      const newPath = location.pathname.replace(/^\/en/, '') || '/';
      navigate(newPath + location.search, { replace: true });
    }
  }, [lang, location.pathname, location.search, navigate]);

  return <Outlet />;
};

export default LanguageRouteWrapper;
